import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'ui/i18n';

import './SearchBox.scss';

const initialState = {
	query: '',
	isValid: true,
};

export default class SearchBox extends Component {
	static propTypes = {
		disabled: PropTypes.bool,
		onSearch: PropTypes.func.isRequired,
		validate: PropTypes.func,
		onChange: PropTypes.func,
		resetOnSearch: PropTypes.bool,
		placeholder: PropTypes.string,
		focusSearchInput: PropTypes.bool,
		iconButton: PropTypes.bool,
		setFocus: PropTypes.func,
	};

	static defaultProps = {
		disabled: false,
		validate: () => true,
		onChange: () => true,
		resetOnSearch: false,
		placeholder: 'Search',
		focusSearchInput: false,
		iconButton: true,
		setFocus: () => false,
	};

	constructor(props) {
		super(props);
		this.state = initialState;
	}

	componentDidMount() {
		if (this.props.focusSearchInput) {
			this.searchInput.focus();
		}
	}

	onQueryChange(event) {
		const query = event.target.value;
		const isValid = query.length ? this.props.validate(query) : true;

		this.setState({ query, isValid });
		this.props.onChange(query, isValid);
	}

	onSearch(event) {
		event.preventDefault();
		if (this.canSubmit()) {
			this.props.onSearch(this.state.query);
			if (this.props.resetOnSearch) {
				this.reset();
			}
		}
	}

	canSubmit() {
		return this.state.query.length && this.props.validate(this.state.query);
	}

	reset() {
		this.setState(initialState);
	}

	onBlur() {
		this.reset();
		this.props.setFocus(false);
	}

	onFocus() {
		this.props.setFocus(true);
	}

	onMouseDown(event) {
		this.onSearch(event);
		event.stopPropagation();
	}

	render() {
		const { disabled, placeholder } = this.props;
		let searchButton;
		if (this.props.iconButton) {
			searchButton = (
				<span className="input-group-btn">
					<button
						id="SearchBtn"
						type="submit"
						className="btn btn-primary iconButton SearchBox-submit"
						disabled={disabled ? disabled : !this.canSubmit()}
						onMouseDown={this.onMouseDown.bind(this)}
					>
						<span className="glyphicon glyphicon-search" aria-hidden="true" />
					</button>
				</span>
			);
		} else {
			searchButton = (
				<span className="input-group-btn">
					<button
						id="SearchBtn"
						type="submit"
						className="btn btn-primary SearchBox-submit"
						disabled={disabled ? disabled : !this.canSubmit()}
						onMouseDown={this.onMouseDown.bind(this)}
					>
						<FormattedMessage id="itemSearch.searchButton" />
					</button>
				</span>
			);
		}

		return (
			<div className="SearchBox">
				<form className="SearchBox-form" onSubmit={this.onSearch.bind(this)}>
					<div className="input-group">
						<input
							ref={input => {
								this.searchInput = input;
							}}
							id="InputSearch"
							type="text"
							className="removeX SearchBox-form-control form-control SearchBox-input"
							placeholder={placeholder}
							value={this.state.query}
							onChange={this.onQueryChange.bind(this)}
							onFocus={this.onFocus.bind(this)}
							onBlur={this.onBlur.bind(this)}
							autoComplete="off"
						/>
						{searchButton}
					</div>
				</form>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/SearchBox/index.js